import { render, staticRenderFns } from "./the-results.vue?vue&type=template&id=9fa0eb5a&scoped=true&"
import script from "./the-results.vue?vue&type=script&lang=js&"
export * from "./the-results.vue?vue&type=script&lang=js&"
import style0 from "./the-results.vue?vue&type=style&index=0&id=9fa0eb5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa0eb5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroSection: require('/opt/build/repo/apps/shop/components/HeroSection.vue').default,LinkButton: require('/opt/build/repo/apps/shop/components/storyblok/LinkButton/LinkButton.vue').default})
